import React from "react";
import {withTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";

function CardStudent(props) {
    const {query, search} = useLocation();
    const {t, i18n,studentProfile,isForFamily,studentHistory} = props;
    const year = +new URLSearchParams(search).get('year');




return (
    <div className={"cardStudent"}>
        {/* ToDo : Revisar carga de datos */}
        <div className={"itemCard itemCardHeader"}>{isForFamily ? t("informes.card.family") : t("informes.card.title")}</div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("login.name")}:</div>
            <div className={"itemCardRight"}>{studentProfile?.name}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("registro.centro")}:</div>
            <div className={"itemCardRight"}>{studentProfile?.center?.name}</div>
        </div>
        {/* ToDo : Poner año accademico automatico */}
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("yeara")}:</div>
            <div className={"itemCardRight"}>20{year}/20{year+1}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("login.course")}:</div>
            <div className={"itemCardRight"}>{studentHistory?.course?.name}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("login.group")}:</div>
            <div className={"itemCardRight"}>{studentHistory && studentHistory.group ? studentHistory.group : studentProfile.group}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("informes.card.email")}:</div>
            <div className={"itemCardRight"}>{studentProfile.username}</div>
        </div>
    </div>
)}

    export default withTranslation()(CardStudent);
